import React, { ComponentProps, FunctionComponent } from "react";

const HealthcareIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 43 40",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M39.1351 3.93206C36.6234 1.39357 33.2861 0 29.7316 0C26.7089 0 23.8371 1.0112 21.5013 2.87904C19.1654 1.0112 16.2937 0 13.2689 0C9.7165 0 6.37702 1.39566 3.86329 3.93415C-1.28845 9.16153 -1.28845 17.6672 3.86742 22.8965C3.86742 22.8965 20.3137 39.5044 20.3301 39.521C20.9488 40.1457 22.0246 40.1728 22.6681 39.523L30.6563 31.4793C31.306 30.8253 31.306 29.7682 30.6605 29.1163C30.017 28.4602 28.9681 28.4602 28.3205 29.1121L21.5012 35.9776L7.06808 21.4027H8.25567C8.88257 21.4027 9.45565 21.0454 9.73706 20.4771L12.557 14.79C12.557 14.79 17.7625 27.0564 17.7709 27.0773C18.3978 28.5544 20.6033 28.3162 20.9157 26.7471L22.515 18.666L24.7432 20.914C25.0536 21.2274 25.4736 21.4029 25.9142 21.4029H28.1218C28.8357 21.4029 29.4667 20.9412 29.6922 20.2601L30.3273 18.3317L30.9625 20.2601C31.188 20.9412 31.8211 21.4029 32.5328 21.4029H35.9342L32.9921 24.3927C32.3487 25.0466 32.3528 26.1059 33.0004 26.7557C33.6438 27.4054 34.6969 27.4013 35.3404 26.7473L39.1328 22.8926C44.2887 17.6673 44.2889 9.16351 39.1351 3.93206ZM38.5248 18.062H33.7289C33.7289 18.062 31.9041 12.5337 31.9 12.5192C31.4075 11.0274 29.2517 11.0317 28.7572 12.5192L26.9283 18.062H26.6014C26.6014 18.062 22.6807 14.1028 22.6724 14.0944C21.762 13.1751 20.1317 13.6744 19.8793 14.9468L18.7186 20.8137C18.7186 20.8137 14.2062 10.1812 14.1979 10.1582C13.6475 8.86704 11.8083 8.82318 11.1938 10.0726L7.23788 18.0623H4.47584C2.52274 14.266 3.07103 9.47942 6.20754 6.29755C10.0455 2.40523 16.4945 2.42609 20.3302 6.29755C20.9509 6.92435 22.0496 6.92227 22.6703 6.29755C26.5247 2.41774 32.9429 2.40731 36.7908 6.29546C39.9295 9.47953 40.4758 14.2634 38.5248 18.062Z",
    })
  );
};

const ForwardRef = React.forwardRef(HealthcareIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
